<div class="toolbar">
  <div class="toolbar-group">
    <!-- Working with forms -->
    <div class="button-group forms-group type-menu-anchor" role="group" aria-label="Forms">
      <button type="button" class="tool-button type-menu-trigger"
        [class.pressed]="typeMenuOpen()"
        aria-haspopup="menu"
        [attr.aria-expanded]="typeMenuOpen()"
        (click)="toggleTypeMenu()"
        title="Create a new form">
        <i class="pi pi-plus"></i>
        <span class="tool-label">New</span>
      </button>
      <button type="button" class="tool-button" (click)="openSavedForms.emit()" title="Open a saved form">
        <i class="pi pi-folder-open"></i>
        <span class="tool-label">Open</span>
      </button>
      <button type="button" class="tool-button" (click)="compare.emit()"
        [disabled]="!hasFormElements()"
        title="Show a saved form beside this one">
        <i class="pi pi-arrow-right-arrow-left"></i>
        <span class="tool-label">Compare</span>
      </button>

      <!-- Form types, under the New button rather than in a modal. -->
      @if (typeMenuOpen()) {
        <div class="menu type-menu" role="menu">
          <p class="menu-heading">What do you want to create?</p>
          @for (option of formTypes; track option.type) {
            <button type="button" class="menu-item type-item" role="menuitem"
              (click)="selectFormType(option.type)">
              @if (option.iconType === 'material') {
                <span class="material-symbols-outlined type-icon">{{ option.icon }}</span>
              } @else {
                <i class="type-icon" [class]="option.icon"></i>
              }
              <span class="type-text">
                <span class="type-label">{{ option.label }}</span>
                <span class="type-description">{{ option.description }}</span>
              </span>
            </button>
          }
        </div>
      }
    </div>

    <button type="button" class="tool-button icon-only"
      [class.pressed]="showQuestionNumbers()"
      [attr.aria-pressed]="showQuestionNumbers()"
      [disabled]="isReadOnly()"
      (click)="toggleQuestionNumbers()"
      [title]="showQuestionNumbers() ? 'Question numbers on' : 'Question numbers off'"
      aria-label="Question numbers">
      <i class="pi pi-hashtag"></i>
    </button>

    <div class="more-menu-anchor">
      <button type="button" class="tool-button icon-only more-menu-trigger"
        [class.pressed]="moreMenuOpen()"
        aria-haspopup="menu"
        [attr.aria-expanded]="moreMenuOpen()"
        aria-label="More actions"
        title="More actions"
        (click)="toggleMoreMenu()">
        <i class="pi pi-ellipsis-h"></i>
      </button>
      @if (moreMenuOpen()) {
        <div class="menu more-menu" role="menu">
          <button type="button" class="menu-item danger" role="menuitem" (click)="onClearClick()">
            <i class="pi pi-eraser"></i>
            <span>Clear form</span>
          </button>
          @if (canArchive()) {
            <button type="button" class="menu-item" role="menuitem" (click)="onArchiveClick()">
              <i class="pi pi-inbox"></i>
              <span>Archive form</span>
            </button>
          }
        </div>
      }
    </div>
  </div>

  <div class="toolbar-group">
    <!-- This form: where it is, and moving it on -->
    @if (!isReadOnly() && hasFormElements()) {
      <span class="save-state" [class.unsaved]="hasUnsavedChanges()">
        @if (hasUnsavedChanges()) {
          <i class="pi pi-exclamation-circle"></i>
        }
        {{ hasUnsavedChanges() ? 'Unsaved changes' : 'Saved' }}
      </span>
    }

    <div class="button-group" role="group" aria-label="Save and publish">
    <button type="button" class="tool-button"
      (click)="saveDraft.emit()"
      [disabled]="isReadOnly() || !hasFormElements()"
      title="Save as draft">
      <i class="pi pi-save"></i>
      <span class="tool-label">Save draft</span>
    </button>
    <button type="button" class="tool-button primary"
      (click)="publish.emit()"
      [disabled]="isReadOnly() || !hasFormElements()"
      title="Publish this form">
      <i class="pi pi-cloud-upload"></i>
      <span class="tool-label">Publish</span>
    </button>
    @if (canPromote()) {
      <button type="button" class="tool-button"
        (click)="onPromotionAction()"
        [disabled]="promoteDisabled()"
        [title]="promoteTitle()">
        <i [class]="promoteIcon()"></i>
        <span class="tool-label">{{ promoteLabel() }}</span>
      </button>
    }
    </div>
  </div>
</div>
